export const cmsMessages = {
  loading: 'Loading...',
  noResults: 'No results!',
  chooseImage: 'Please select an image',
  upload: 'Please choose an image to upload',
  deleteContest: 'Are you sure you want to delete this contest?',
  deleteSuccess: 'Contest deleted successfully!',
  createSuccess: 'Contest created successfully!',
  saveSuccess: 'Changes Saved!',
  updateSuccess: 'Updated Successfully!',
  endDateLessThanStartDate: 'End date should not be less then start date or current date',
  sponsorEndDateLessThanStartDate: 'Sponsor start date should be greater than current date and less than end date',
  sponsorCompanyEmpty: 'Please select sponsor company',
  activeSponsorError: 'Cannot change start date and company for the active sponsored contest',
  archiveSubmission: 'Are you sure you want to archive this submission?',
  archivedSuccess: 'Archived successfully',
  archivedFailed: 'Failed to archive submission',
};

export const cmsStatus = {
  noChallenge: 'Please select challenge first, to create contest...',
  savingChanges: 'Saving Changes',
  updating: 'Updating Contest',
  creating: 'Creating Contest',
  loading: 'Loading Contest',
  defaultError: 'Oops! Something went wrong while creating contest. Please Try again',
};

export const cmsTabs = {
  jobs: 'jobs',
  tests: 'tests',
  candidates: 'candidates',
  messages: 'messages',
  landing: 'landing',
  branding: 'branding',
  duration: 'duration',
  compDesc: 'compDesc',
  candDesc: 'candDesc',
  sponsor: 'sponsor',
  logo: 'logo',
  landingPageLogo: 'landingPageLogo',
  background: 'background',
  runTournament: 'runTournament',
};

export const testSortFields = {
  name: 'name',
  category: 'category',
  status: 'isActive',
  edited: 'editedAt',
  created: 'createdAt',
  isTournament: 'isTournament',
};

// Languages should be sorted in the same order as in the client enums.json
export const contestLanguages = [
  { label: 'All', value: '' },
  { label: 'C', value: 'c', icon: <i className="devicon-c-plain colored mr-1"></i> },
  { label: 'C#', value: 'c_sharp', icon: <i className="devicon-csharp-plain colored mr-1"></i> },
  { label: 'C++', value: 'cpp', icon: <i className="devicon-cplusplus-plain colored mr-1"></i> },
  { label: 'Go', value: 'go', icon: <i className="devicon-go-original-wordmark colored mr-1"></i> },
  { label: 'Java', value: 'java', icon: <i className="devicon-java-plain colored mr-1"></i> },
  { label: 'Javascript', value: 'javascript', icon: <i className="devicon-javascript-plain colored mr-1"></i> },
  { label: 'Kotlin', value: 'kotlin', icon: <i className="devicon-kotlin-plain colored mr-1"></i> },
  { label: 'PHP', value: 'php', icon: <i className="devicon-php-plain colored mr-1"></i> },
  { label: 'Python', value: 'python', icon: <i className="devicon-python-plain colored mr-1"></i> },
  { label: 'Ruby', value: 'ruby', icon: <i className="devicon-ruby-plain colored mr-1"></i> },
  { label: 'Rust', value: 'rust', icon: <i className="devicon-rust-plain colored mr-1"></i> },
  { label: 'Scala', value: 'scala', icon: <i className="devicon-scala-plain colored mr-1"></i> },
  { label: 'Typescript', value: 'typescript', icon: <i className="devicon-typescript-plain colored mr-1"></i> },
];

export const userRoles = {
  SUPER_ADMIN: 'super-admin',
  COMPANY_ADMIN: 'company-admin',
  DEPARTMENT_ADMIN: 'department-admin',
  EMPLOYEE: 'customer',
  CANDIDATE: 'candidate',
  RESELLER: 'reseller',
};

export const categories = {
  CHALLENGE: { category: 'challenge', simpleName: 'Challenge' },
  EXERCISE: { category: 'exercise', simpleName: 'Exercise' },
  FREECODE: { category: 'exercise', simpleName: 'Freecode' },
  CODE: { category: 'code', simpleName: 'Code Tests' },
  GENERAL_SKILLS: { category: 'General Skills', simpleName: 'General Skills' },
  MULTICHOICE: { category: 'Multiple Choice Programming', simpleName: 'Multichoice' },
};

export const paymentTabs = {
  recurring: 'recurring',
  purchase: 'purchase',
};

export const FeedbackForm = [
  {
    question: 'How was your overall experience taking this test?',
    options: ['Poor', 'Fair', 'Good', 'Very Good'],
  },
  {
    question: 'Did you feel that you had enough time to finish the test?',
    options: ['Not Enough', 'Precisely timed', 'Sufficient', 'Plentiful'],
  },
  {
    question: 'How was the difficulty of the test in relation to the job position?',
    options: ['Difficult', 'Slightly difficult', 'Average', 'Easy'],
  },
];

export const websiteRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/; //eslint-disable-line
export const phoneNumberRegex = /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/; //eslint-disable-line
export const zipRegex = /^[0-9 -]*$/;
export const objectIdRegex = /^[0-9a-fA-F]{24}$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W\_]{10,}$/; //eslint-disable-line

export const emailTemplatePlaceholder = [
  {
    mailTemplate: [
      'Candidate first name',
      'Candidate name',
      'Candidate email',
      'Customer first name',
      'Customer name',
      'Company name',
      'Dashboard URL',
      'Job Title',
      'Score',
      'Test ticket URL',
      'Test',
      'Time',
      'Invite link',
    ],
  },
];

export const Languages = {
  c: {
    EditorName: 'c_cpp',
    SimpleName: 'C',
  },
  c_sharp: {
    EditorName: 'csharp',
    SimpleName: 'C# .NET',
  },
  cpp: {
    EditorName: 'c_cpp',
    SimpleName: 'C++',
  },
  go: {
    EditorName: 'golang',
    SimpleName: 'Go',
  },
  java: {
    EditorName: 'java',
    SimpleName: 'Java',
  },
  javascript: {
    EditorName: 'javascript',
    SimpleName: 'Javascript',
  },
  kotlin: {
    EditorName: 'kotlin',
    SimpleName: 'Kotlin',
  },
  php: {
    EditorName: 'php',
    SimpleName: 'PHP',
  },
  python: {
    EditorName: 'python',
    SimpleName: 'Python',
  },
  ruby: {
    EditorName: 'ruby',
    SimpleName: 'Ruby',
  },
  rust: {
    EditorName: 'rust',
    SimpleName: 'Rust',
  },
  scala: {
    EditorName: 'scala',
    SimpleName: 'Scala',
  },
  typescript: {
    EditorName: 'typescript',
    SimpleName: 'Typescript',
  },
};

export const QuestionDifficulties = {
  VERY_HARD: {
    id: 'very_hard',
    name: 'Very Hard',
    limit: 1150,
  },
  HARD: {
    id: 'hard',
    name: 'Hard',
    limit: 1050,
  },
  MEDIUM: {
    id: 'medium',
    name: 'Medium',
    limit: 950,
  },
  EASY: {
    id: 'easy',
    name: 'Easy',
    limit: 850, // above
  },
  VERY_EASY: {
    id: 'very_easy',
    name: 'Very Easy',
    limit: 850, // below
  },
};

export const contestDefaultThumbnail =
  'https://sws-uploads.s3.eu-central-1.amazonaws.com/5b1a71814930bd59dda45dfe/60af655bb705932a147b4a8b-background-thumbnail.jpeg';
